import React from "react";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { isDateValid } from "../../../../../../../shared/validators/validator";
import "../../../../styles/ExpressionBuilder.css";

/**
 * Date input component for expression rule values
 * @param {Object} rest - Props to pass to Input component
 * @returns {JSX.Element} Date input component
 * @author Abhishek Dhillon
 * @parent ValueInput
 */
const DateInput = ({ value, ...rest }) => {
  const handleChange = (e) => {
    rest.onValueChange(e.target.value);
  };

  const getDateValue = () => {
    if (value) {
      const date = new Date(value);
      return isNaN(date.getTime()) ? null : date;
    }
    return null;
  };

  return (
    <DatePicker
      type='date'
      id='value-input-date'
      className='expression-builder-w-100'
      placeholder='Select date'
      valid={getDateValue() && isDateValid(getDateValue())}
      value={getDateValue()}
      onChange={handleChange}
    />
  );
};

export default DateInput;
